import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "../../../src/components/Reveal";

export default function AboutSummary() {
  return (
    <section data-testid="home-about" className="bg-white section-pad">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <Reveal className="lg:col-span-6">
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1758518730384-be3d205838e8"
              alt="Reunión de profesionales en firma de abogados"
              loading="lazy"
              className="w-full aspect-[4/5] object-cover"
            />
            <div
              className="absolute -bottom-6 -right-6 hidden md:block bg-white px-6 py-5 max-w-[280px] border-l-2"
              style={{ borderColor: "#C5A059" }}
            >
              <p className="font-serif italic text-navy-900 text-base leading-snug">
                "No solo resolvemos problemas, prevenimos riesgos y fortalecemos decisiones."
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal className="lg:col-span-6" delay={120}>
          <div className="flex items-center gap-3 mb-5">
            <span className="gold-rule" />
            <span className="overline">Quiénes somos</span>
          </div>
          <h2 className="font-serif text-navy-900 text-3xl md:text-4xl lg:text-5xl leading-tight">
            Una firma <em className="italic" style={{ color: "#C5A059" }}>multidisciplinaria</em> con rigor técnico y enfoque estratégico.
          </h2>
          <p className="mt-6 text-slate-600 leading-relaxed text-base md:text-[17px]">
            Ospino &amp; Piñeres Abogados &amp; Asociados S.A.S. es una firma multidisciplinaria de abogados y contadores reconocida por su rigor técnico, ética profesional y compromiso institucional. Diseñamos soluciones jurídicas y contables adaptadas a la dinámica empresarial de cada cliente.
          </p>

          <ul className="mt-8 space-y-3">
            {[
              "Ética y transparencia",
              "Excelencia técnica",
              "Trabajo colaborativo y multidisciplinario",
              "Acompañamiento personalizado",
            ].map((p) => (
              <li key={p} className="flex items-start gap-3 text-slate-700 text-[15px]">
                <span
                  className="mt-2 inline-block w-2 h-px"
                  style={{ background: "#C5A059" }}
                />
                {p}
              </li>
            ))}
          </ul>

          <Link
            to="/firma"
            data-testid="about-cta-conocer-mas"
            className="mt-9 inline-flex items-center gap-2 text-sm font-medium text-navy-900 under-gold"
          >
            Conocer más sobre la firma
            <ArrowRight size={15} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}